// extracted by mini-css-extract-plugin
export default {"lang":"LanguageSelector_lang__kD6RD","menu":"LanguageSelector_menu__8Fuuw"};